import { GenderType } from './../../interface/avatar.interface';
import { LayerItemConfig } from './../../interface/layer.interface';
const mouthConfig: LayerItemConfig[] = [
  {
    filename: 'Frown',
    genderType: GenderType.UNSET,
    weight: 10,
  },
  {
    filename: 'indifferent',
    genderType: GenderType.UNSET,
    weight: 10,
  },
  {
    filename: 'Laughing',
    genderType: GenderType.UNSET,
    weight: 10,
  },
  {
    filename: 'Nervous',
    genderType: GenderType.UNSET,
    weight: 10,
  },
  {
    filename: 'open',
    genderType: GenderType.UNSET,
    weight: 10,
  },
  {
    filename: 'Pucker',
    genderType: GenderType.UNSET,
    weight: 10,
  },
  {
    filename: 'QY-01',
    genderType: GenderType.UNSET,
    weight: 10,
  },
  {
    filename: 'Sad',
    genderType: GenderType.UNSET,
    weight: 10,
  },
  {
    filename: 'Smile-1',
    genderType: GenderType.UNSET,
    weight: 10,
  },
  {
    filename: 'Smile-2',
    genderType: GenderType.UNSET,
    weight: 10,
  },
  {
    filename: 'Smile',
    genderType: GenderType.UNSET,
    weight: 10,
  },
];

export default mouthConfig;
